{
  "ALREADY_ADDED": "This device has already been added to your farm account.",
  "ALREADY_CLAIMED": "The device has already been claimed by another farm. If you are sharing the device with the owner farm, you can add it to your account with a device share code provided to you by the owner. If you believe this is an error, please contact customer support.",
  "EXPIRED": "The code you entered is expired.",
  "INVALID_ALIAS": "The device alias you entered is invalid. Please double-check and try again.",
  "INVALID_SHARE_CODE": "The device share code you entered is invalid. Please double-check and try again.",
  "MUST_NOT_MATCH": "The device you are replacing must be different from the new device.",
  "addDeviceButton": "Add Device",
  "addMoreDevicesButton": "Add More Devices",
  "codaDeviceAliasFieldLabel": "Enter Product Alias",
  "codaDeviceAliasHelpLink": "Where is my device alias?",
  "codaDeviceAliasHelpText": "Your FarmHQ Device can be identified by its product alias, which is an easy-to-read unique identifier printed on the device.",
  "codaDeviceAliasHelpTitle": "Locating Your Device Alias",
  "codaDeviceAliasInputMode": "Device Alias",
  "codaDeviceAliasInputPlaceholder": "(xxxx-xxxx)",
  "codaDeviceAliasInstructions": "In order to enable your FarmHQ device, we need to validate its product alias.",
  "codaDeviceAliasToggleText": "Have a device share code?",
  "deviceShareCodeFieldLabel": "Enter Device Share Code",
  "deviceShareCodeHelpLink": "Where is my device share code?",
  "deviceShareCodeHelpText": "Device Share Codes allow you to give another farm temporary access to use one of your devices",
  "deviceShareCodeHelpTitle": "Getting a Device Share Code",
  "deviceShareCodeInputMode": "Device Share Code",
  "deviceShareCodeInputPlaceholder": "(XXXXXX)",
  "deviceShareCodeInstructions": "Enter the device share code provided to you by the owner farm.",
  "deviceShareCodeToggleText": "Use a coda device alias",
  "deviceToReplace": "Device to Replace",
  "enterNewDeviceAlias": "Enter New Device Alias",
  "iUnderstand": "I understand and want to proceed",
  "ifYouAreUnsure": "If you are unsure, please contact FarmHQ support.",
  "isReplacementDevice": "Replace existing device?",
  "noDevicesToReplace": "No devices to replace",
  "noDevicesToReplaceMessage": "This feature is intended to replace an existing device with a new device, while keeping the same configuration, permissions, and connections. Users would typically do this when they are upgrading their hardware and do not want to make any software changes.\n\nIf you do not have a device to replace, simply enter the alias and press submit.",
  "note": "Note: ",
  "replacementDeviceDescriptionWithOldDeviceAliasAndNewDeviceAlias": "This will copy configuration information, connections, and other data from the old device ({{oldDeviceAlias}}) to the new device ({{newDeviceAlias}}).\n\nHistorical data reported from sensors will not be copied.\n\nThe old device will be removed from your farm account.",
  "replacementDevicePlaceholder": "(Select device)",
  "selectOldDevice": "Select Old Device",
  "setUpDeviceButton": "Set Up",
  "successDescription": "The device has been added to your farm account.",
  "title": "Add Device"
}
